import React from 'react'
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../common/helpers.mjs'
//@ts-ignore
import { coreProductType, currencyObject, Product } from '../common/types/types'
import useLocalization from '../hooks/useLocalization'

interface ThingsYouNeedToKnowProps {
   coreProductSelected: string
   productCoreEECount: number
   hasPayroll: boolean
   hasTimeTracking: boolean
   hasTimeAttendance: boolean
   timeProductSelected: string
   pricebookID: number
   showPrepaymentDisclaimer: boolean
   currencyObject: currencyObject
   product_list: { [key: string]: Product }
   currencyObjectUSD: currencyObject
   hasEORGeo2: boolean
   formType: number
   hasManagedOrConsultingService: boolean
}

export default function ThingsYouNeedToKnow({
   coreProductSelected,
   productCoreEECount,
   hasPayroll,
   hasTimeTracking,
   hasTimeAttendance,
   timeProductSelected,
   pricebookID,
   showPrepaymentDisclaimer,
   currencyObject,
   product_list,
   currencyObjectUSD,
   hasEORGeo2,
   formType,
   hasManagedOrConsultingService,
}: ThingsYouNeedToKnowProps): React.ReactElement {
   const host_url =
      process.env.REACT_APP_HOST_URL || 'https://quote.bamboohr.net'
   const { getString, getFormattedString, getFormattedJSX } =
      useLocalization(host_url)

   function GetMinimumListPriceAsCurrency(
      productCode: string,
      currencyObject: currencyObject,
   ): string {
      const basePrice = product_list?.[productCode]?.MinimumListPrice
      return formatFloatAsCurrencySymbol(basePrice || 0, currencyObject)
   }

   function NumberToCurrencyRate(number: number): string {
      return formatFloatAsCurrencySymbol(number, currencyObject)
   }

   if (pricebookID < 200) {
      if (productCoreEECount > 20 && !hasPayroll)
         return (
            <div className='fullWidth'>
               <strong>
                  Things you need to know in connection with this price quote:
               </strong>
               <ol type='1'>
                  <li>
                     Prices quoted above are based on your agreement to
                     subscribe to the above noted services, and represents the
                     number of active employees that you have indicated will be
                     added to BambooHR when fully implemented. You will be
                     billed for the employee headcount quoted above until that
                     number is exceeded. Should your number of employees change
                     after your quoted headcount is exceeded, or subscribe to
                     additional services, your prices may increase or decrease.
                  </li>
                  <li>
                     Payment for services, including implementation, are due
                     immediately upon acceptance of this price quote. Your
                     monthly per employee rates or monthly flat rate
                     subscriptions will renew on a month-to-month basis until
                     terminated.
                  </li>
                  {coreProductSelected !== coreProductType.None && (
                     <li>
                        Pricing is dependent on the number of employees using
                        each product. In months with 20 or fewer employees you
                        will be charged a flat monthly rate of{' '}
                        {NumberToCurrencyRate(
                           coreProductSelected === coreProductType.Core
                              ? 108
                              : 180,
                        )}
                        .
                     </li>
                  )}
                  {hasTimeTracking && (
                     <li>
                        Time Tracking pricing is dependent on the number of
                        employees using Time Tracking. In months where there are
                        3 or fewer employees using Time Tracking a flat rate of
                        $9.00 will be charged to your account.
                     </li>
                  )}
                  <li>
                     This price quote reflects your estimated monthly
                     subscription cost. For add-on products, excluding Payroll,
                     the first invoice will be due upon activation for the
                     prorated amount between that day and your next billing
                     date.
                  </li>
                  {showPrepaymentDisclaimer && (
                     <li>
                        This prepayment request is an estimation of service
                        based on your current headcount, subscription and
                        pricing. Note that any changes to your headcount,
                        subscription products, or pricing will affect the
                        estimated coverage period. Once paid, this will be added
                        to your account as a credit. The actual number of active
                        employees in the account during the month will be used
                        to calculate your invoices. Those invoices will be
                        deducted from the prepayment credit balance.
                     </li>
                  )}
                  <li>
                     BambooHR's services are governed by our Terms of Service
                     found at https://www.bamboohr.com/legal/terms-of-service;
                     payroll services are governed by our Payroll Services
                     Agreement found at
                     https://www.bamboohr.com/legal/payroll-services-agreement.
                     Both agreements are formally accepted in the product.
                  </li>
                  <li>
                     Please contact your BambooHR sales representative with any
                     questions or changes, or you may contact customer support
                     at 801-724-6600.
                  </li>
               </ol>
            </div>
         )
      else if (productCoreEECount <= 20 && !hasPayroll)
         return (
            <div className='fullWidth'>
               <strong>
                  Things you need to know in connection with this price quote:
               </strong>
               <ol type='1'>
                  <li>
                     Prices quoted above are based on your agreement to
                     subscribe to the above noted services, and represent the
                     number of active employees that you have indicated will be
                     added to BambooHR when fully implemented. Should your
                     number of employees change, or subscribe to additional
                     services, your prices may increase or decrease.
                  </li>
                  <li>
                     Payment for services, including implementation, are due
                     immediately upon acceptance of this price quote. Your
                     monthly per employee rates or monthly flat rate
                     subscriptions will renew on a month-to-month basis until
                     terminated.
                  </li>
                  {coreProductSelected !== coreProductType.None && (
                     <li>
                        Pricing is dependent on the number of employees using
                        each product. In months with 20 or fewer employees you
                        will be charged a flat monthly rate of{' '}
                        {NumberToCurrencyRate(
                           coreProductSelected === coreProductType.Core
                              ? 108
                              : 180,
                        )}
                        .
                     </li>
                  )}
                  {hasTimeTracking && (
                     <li>
                        Time Tracking pricing is dependent on the number of
                        employees using Time Tracking. In months where there are
                        3 or fewer employees using Time Tracking a flat rate of
                        $9.00 will be charged to your account.
                     </li>
                  )}
                  <li>
                     This price quote reflects your estimated monthly
                     subscription cost. For add-on products, excluding Payroll,
                     the first invoice will be due upon activation for the
                     prorated amount between that day and your next billing
                     date.
                  </li>
                  {showPrepaymentDisclaimer && (
                     <li>
                        This prepayment request is an estimation of service
                        based on your current headcount, subscription and
                        pricing. Note that any changes to your headcount,
                        subscription products, or pricing will affect the
                        estimated coverage period. Once paid, this will be added
                        to your account as a credit. The actual number of active
                        employees in the account during the month will be used
                        to calculate your invoices. Those invoices will be
                        deducted from the prepayment credit balance.
                     </li>
                  )}
                  <li>
                     BambooHR's services are governed by our Terms of Service
                     found at https://www.bamboohr.com/legal/terms-of-service;
                     payroll services are governed by our Payroll Services
                     Agreement found at
                     https://www.bamboohr.com/legal/payroll-services-agreement.
                     Both agreements are formally accepted in the product.
                  </li>
                  <li>
                     Please contact your BambooHR sales representative with any
                     questions or changes, or you may contact customer support
                     at 801-724-6600.
                  </li>
               </ol>
            </div>
         )
      else if (productCoreEECount <= 20 && hasPayroll)
         return (
            <div className='fullWidth'>
               <strong>
                  Things you need to know in connection with this price quote:
               </strong>
               <ol type='1'>
                  <li>
                     Prices quoted above are based on your agreement to
                     subscribe to the above noted services, and represent the
                     number of active employees that you have indicated will be
                     added to BambooHR when fully implemented. Should your
                     number of employees change, or subscribe to additional
                     services, your prices may increase or decrease.
                  </li>
                  <li>
                     Payment for services, including implementation, becomes due
                     when you become a subscriber of BambooHR services. Your
                     first payment will be due immediately upon your acceptance
                     of this price quote and your subscription will renew on a
                     month-to-month basis until terminated. Payment for Payroll
                     services, not including implementation, are due at the
                     first payroll run. For Payroll, monthly per employee rates
                     and any applicable ancillary charges will be due
                     incrementally as payroll runs are processed.
                  </li>
                  {coreProductSelected !== coreProductType.None && (
                     <li>
                        Pricing is dependent on the number of employees using
                        each product. In months with 20 or fewer employees you
                        will be charged a flat monthly rate of{' '}
                        {NumberToCurrencyRate(
                           coreProductSelected === coreProductType.Core
                              ? 108
                              : 180,
                        )}
                        .
                     </li>
                  )}
                  {hasTimeTracking && (
                     <li>
                        Time Tracking pricing is dependent on the number of
                        employees using Time Tracking. In months where there are
                        3 or fewer employees using Time Tracking a flat rate of
                        $9.00 will be charged to your account.
                     </li>
                  )}
                  <li>
                     Payroll pricing is dependent on the number of employees you
                     paid in the previous calendar month. In months where 20 or
                     fewer employees are paid a flat rate of{' '}
                     {NumberToCurrencyRate(150)} will be charged to your
                     account.
                  </li>
                  <li>
                     This price quote reflects your estimated monthly
                     subscription cost. For add-on products, excluding Payroll,
                     the first invoice will be due upon activation for the
                     prorated amount between that day and your next billing
                     date.
                  </li>
                  <li>
                     If you postpone your scheduled payroll implementation date,
                     you will be charged {NumberToCurrencyRate(300)} for each
                     postponement.
                  </li>
                  <li>
                     W2 and 1099 forms will be mailed to all terminated
                     employees. Additionally, employees electing to only receive
                     a digital copy will need to opt-in within BambooHR,
                     otherwise, they will receive a mailed copy.
                  </li>
                  {showPrepaymentDisclaimer && (
                     <li>
                        This prepayment request is an estimation of service
                        based on your current headcount, subscription and
                        pricing. Note that any changes to your headcount,
                        subscription products, or pricing will affect the
                        estimated coverage period. Once paid, this will be added
                        to your account as a credit. The actual number of active
                        employees in the account during the month will be used
                        to calculate your invoices. Those invoices will be
                        deducted from the prepayment credit balance.
                     </li>
                  )}
                  <li>
                     BambooHR's services are governed by our Terms of Service
                     found at https://www.bamboohr.com/legal/terms-of-service;
                     payroll services are governed by our Payroll Services
                     Agreement found at
                     https://www.bamboohr.com/legal/payroll-services-agreement.
                     Both agreements are formally accepted in the product.
                  </li>
                  <li>
                     Please contact your BambooHR sales representative with any
                     questions or changes, or you may contact customer support
                     at 801-724-6600.
                  </li>
               </ol>
            </div>
         )
      else if (productCoreEECount > 20 && hasPayroll)
         return (
            <div className='fullWidth'>
               <strong>
                  Things you need to know in connection with this price quote:
               </strong>
               <ol type='1'>
                  <li>
                     Prices quoted above are based on your agreement to
                     subscribe to the above noted services, and represent the
                     number of active employees that you have indicated will be
                     added to BambooHR when fully implemented. You will be
                     billed for the employee headcount quoted above until that
                     number is exceeded. Should your number of employees change
                     after your quoted headcount is exceeded, or subscribe to
                     additional services, your prices may increase or decrease.
                  </li>
                  <li>
                     Payment for services, including implementation, becomes due
                     when you become a subscriber of BambooHR services. Your
                     first payment will be due immediately upon your acceptance
                     of this price quote and your subscription will renew on a
                     month-to-month basis until terminated. Payment for Payroll
                     services, not including implementation, are due at the
                     first payroll run. For Payroll, monthly per employee rates
                     and any applicable ancillary charges will be due
                     incrementally as payroll runs are processed.
                  </li>
                  {coreProductSelected !== coreProductType.None && (
                     <li>
                        Pricing is dependent on the number of employees using
                        each product. In months with 20 or fewer employees you
                        will be charged a flat monthly rate of{' '}
                        {NumberToCurrencyRate(
                           coreProductSelected === coreProductType.Core
                              ? 108
                              : 180,
                        )}
                        .
                     </li>
                  )}
                  {hasTimeTracking && (
                     <li>
                        Time Tracking pricing is dependent on the number of
                        employees using Time Tracking. In months where there are
                        3 or fewer employees using Time Tracking a flat rate of
                        $9.00 will be charged to your account.
                     </li>
                  )}
                  <li>
                     Payroll pricing is dependent on the number of employees you
                     paid in the previous calendar month. In months where 20 or
                     fewer employees are paid a flat rate of{' '}
                     {NumberToCurrencyRate(150)} will be charged to your
                     account.
                  </li>
                  <li>
                     This price quote reflects your estimated monthly
                     subscription cost. For add-on products, excluding Payroll,
                     the first invoice will be due upon activation for the
                     prorated amount between that day and your next billing
                     date.
                  </li>
                  <li>
                     If you postpone your scheduled payroll implementation date,
                     you will be charged {NumberToCurrencyRate(300)} for each
                     postponement.
                  </li>
                  <li>
                     W2 and 1099 forms will be mailed to all terminated
                     employees. Additionally, employees electing to only receive
                     a digital copy will need to opt-in within BambooHR,
                     otherwise, they will receive a mailed copy.
                  </li>
                  {showPrepaymentDisclaimer && (
                     <li>
                        This prepayment request is an estimation of service
                        based on your current headcount, subscription and
                        pricing. Note that any changes to your headcount,
                        subscription products, or pricing will affect the
                        estimated coverage period. Once paid, this will be added
                        to your account as a credit. The actual number of active
                        employees in the account during the month will be used
                        to calculate your invoices. Those invoices will be
                        deducted from the prepayment credit balance.
                     </li>
                  )}
                  <li>
                     BambooHR's services are governed by our Terms of Service
                     found at https://www.bamboohr.com/legal/terms-of-service;
                     payroll services are governed by our Payroll Services
                     Agreement found at
                     https://www.bamboohr.com/legal/payroll-services-agreement.
                     Both agreements are formally accepted in the product.
                  </li>
                  <li>
                     Please contact your BambooHR sales representative with any
                     questions or changes, or you may contact customer support
                     at 801-724-6600.
                  </li>
               </ol>
            </div>
         )
   } else if (pricebookID >= 200) {
      const formTypeMap = {
         formType: formType < 4 ? 'price quote' : 'Order Form',
      }
      return (
         <div className='fullWidth'>
            <strong>
               {getFormattedString(
                  'quote.thingsYouNeedToKnow.header',
                  formTypeMap,
                  'Things you need to know in connection with this {formType}:',
               )}
            </strong>
            <ol type='1'>
               <li>
                  {getString(
                     'quote.thingsYouNeedToKnow.pricesQuoted',
                     'Prices above represent the number of active employees you have indicated will be added to BambooHR when fully implemented.',
                  )}{' '}
                  {productCoreEECount <= 25
                     ? getString(
                          'quote.thingsYouNeedToKnow.EEBelowMin',
                          'Should your number of employees change, or subscribe to additional services, your prices may increase or decrease.',
                       )
                     : getString(
                          'quote.thingsYouNeedToKnow.employeeChangeHigh',
                          'You will be billed for the employee headcount above until that number is exceeded. Should your number of employees change after your designated headcount is exceeded, or subscribe to additional services, your prices may change.',
                       )}
               </li>
               <li>
                  {getFormattedString(
                     'quote.thingsYouNeedToKnow.paymentDue',
                     formTypeMap,
                     'Payment for services, including implementation, are due immediately upon acceptance of this {formType}. Core/Pro/Elite and add-ons monthly per employee rates or monthly flat rate subscriptions will automatically renew for successive renewal terms per Section 5.1 of the Terms of Service or until terminated (See Sections 2.3 & 2.4 of the Terms of Service).',
                  )}{' '}
                  {hasPayroll && (
                     <>
                        {' '}
                        {getString(
                           'quote.thingsYouNeedToKnow.payrollPayment',
                           'Payment for Payroll services, not including implementation, are due at the first payroll run. For Payroll any applicable ancillary charges will be due incrementally as payroll runs are processed.',
                        )}
                     </>
                  )}
               </li>
               {coreProductSelected !== coreProductType.None && (
                  <li>
                     {getFormattedString(
                        'quote.thingsYouNeedToKnow.pricingDependent',
                        {
                           pricingType: hasPayroll ? 'Pricing' : 'HR pricing',
                           minPrice: GetMinimumListPriceAsCurrency(
                              coreProductSelected,
                              currencyObject,
                           ),
                           ...formTypeMap,
                        },
                        '{pricingType} is dependent on the number of employees using each product. If you are an Extended Term Customer, you acknowledge and agree that the Per-Employee-Per-Month ("PEPM") identified on {formType} is the minimum PEPM you will be billed for the duration of your subscription term, regardless of actual usage or any reduction in the number of active users. Please see Section 5.6 of the Terms of Service for more details regarding minimum PEPM. If you are a month to month customer, in months where 25 or fewer employees you will be charged a flat monthly rate of {minPrice}.',
                     )}
                  </li>
               )}
               {(timeProductSelected === 'timeAttendance'
                  ? hasTimeAttendance
                  : hasTimeTracking) && (
                  <li>
                     {getFormattedString(
                        'quote.thingsYouNeedToKnow.timeProductPricing',
                        {
                           minPrice: GetMinimumListPriceAsCurrency(
                              timeProductSelected,
                              currencyObjectUSD,
                           ),
                           productName:
                              timeProductSelected === 'timeTracking'
                                 ? 'Time Tracking'
                                 : 'Time & Attendance',
                        },
                        '{productName} pricing is dependent on the number of employees using {productName}. In months where there are 3 or fewer employees using {productName} a flat rate of {minPrice} will be charged to your account.',
                     )}
                  </li>
               )}
               {hasPayroll && (
                  <>
                     <li>
                        {getFormattedString(
                           'quote.thingsYouNeedToKnow.payrollPricing',
                           {
                              minPrice: GetMinimumListPriceAsCurrency(
                                 'payroll',
                                 currencyObjectUSD,
                              ),
                           },
                           'Payroll pricing is dependent on the number of employees you paid in the previous calendar month. In months where 25 or fewer employees are paid a flat rate of {minPrice} will be charged to your account.',
                        )}
                     </li>
                     <li>
                        {getFormattedString(
                           'quote.thingsYouNeedToKnow.accountManagementFee',
                           {
                              fee: formatFloatAsCurrencySymbol(
                                 125,
                                 currencyObjectUSD,
                              ),
                           },
                           'In months where a Payroll run has not occurred, you will be charged an account management fee of {fee}.',
                        )}
                     </li>
                     <li>
                        {getFormattedString(
                           'quote.thingsYouNeedToKnow.ytdDataEntry',
                           {
                              fee: formatFloatAsCurrencySymbol(
                                 300,
                                 currencyObjectUSD,
                              ),
                           },
                           'If you postpone your scheduled payroll implementation date, you will be charged {fee} for each postponement.',
                        )}
                     </li>
                     <li>
                        {getString(
                           'quote.thingsYouNeedToKnow.w2Forms',
                           'W2 and 1099 forms will be mailed to all terminated employees. Additionally, employees electing to only receive a digital copy will need to opt-in within BambooHR, otherwise, they will receive a mailed copy.',
                        )}
                     </li>
                     <li>
                        {getString(
                           'quote.thingsYouNeedToKnow.initialPayrollFundingPeriod',
                           'Initial Payroll funding period: New payroll customers fund payroll via wire transfer, ACH credit, RTP, FedNow, reverse wire or 4-day ACH for the first three (3) months after payroll setup. After this period, 2-day ACH may become available based on eligibility',
                        )}
                     </li>
                  </>
               )}
               {showPrepaymentDisclaimer && (
                  <li>
                     {getString(
                        'quote.thingsYouNeedToKnow.prepaymentDisclaimer',
                        'This prepayment request is an estimation of service based on your current headcount, subscription and pricing. Note that any changes to your headcount, subscription products, or pricing will affect the estimated coverage period. Once paid, this will be added to your account as a credit. The actual number of active employees in the account during the month will be used to calculate your invoices. Those invoices will be deducted from the prepayment credit balance.',
                     )}
                  </li>
               )}
               {hasEORGeo2 && (
                  <li>
                     {getString(
                        'quote.thingsYouNeedToKnow.eorGeo2',
                        'Employer of Record - Region 2 pricing only applies to employees hired in India and the Philippines.',
                     )}
                  </li>
               )}
               <li>
                  {getFormattedJSX(
                     'quote.thingsYouNeedToKnow.termsOfService',
                     {
                        tosLink: (
                           <a
                              href='https://www.bamboohr.com/legal/terms-of-service'
                              target='_blank'
                              rel='noopener noreferrer'
                           >
                              https://www.bamboohr.com/legal/terms-of-service
                           </a>
                        ),
                        payrollLink: (
                           <a
                              href='https://www.bamboohr.com/legal/payroll-services-agreement'
                              target='_blank'
                              rel='noopener noreferrer'
                           >
                              https://www.bamboohr.com/legal/payroll-services-agreement
                           </a>
                        ),
                     },
                     "BambooHR's services are governed by our Terms of Service found at {tosLink}; payroll services are governed by our Payroll Services Agreement found at {payrollLink}. Both agreements are formally accepted in the product.",
                  )}
                  {hasManagedOrConsultingService && (
                     <>
                        {' '}
                        {getFormattedJSX(
                           'quote.thingsYouNeedToKnow.managedServices',
                           {
                              managedServicesLink: (
                                 <a
                                    href='https://www.bamboohr.com/legal/hr-consulting-and-managed-payroll-services-addendum'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                 >
                                    https://www.bamboohr.com/legal/hr-consulting-and-managed-payroll-services-addendum
                                 </a>
                              ),
                           },
                           'Managed and Consulting Services are governed by an addendum found at {managedServicesLink}.',
                        )}
                     </>
                  )}
               </li>
               <li>
                  {getString(
                     'quote.thingsYouNeedToKnow.contactSupport',
                     'Please contact your BambooHR sales representative with any questions or changes, or you may contact customer support at 801-724-6600.',
                  )}
               </li>
            </ol>
         </div>
      )
   } else {
      return <></>
   }
   // Default return to satisfy TypeScript
   return <></>
}
